import { feature as accountActions } from '@central-products/account-actions';
import { feature as accountActionsHandler } from '@central-products/account-actions-handler';
import { feature as accountFlags } from '@central-products/account-flags';
import { feature as accountFlagsFlow } from '@central-products/account-flags-flow';
import { feature as accountInfo } from '@central-products/account-info';
import { feature as accountPreferences } from '@central-products/account-preferences';
import { feature as loginFlow } from '@central-products/login-flow';
import { feature as recaptchaService } from '@central-products/recaptcha-service';
import { feature as registrationFlow } from '@central-products/registration-flow';
import { feature as graphqlClient } from '@central-products/graphql-client';
import { feature as casSessionManager } from '@central-products/cas-session-manager';
import { feature as oauthSessionManager } from '@central-products/oauth-session-manager';
import { feature as sessionService } from '@central-products/session-service';
import { feature as myaccountService } from '@myaccount/myaccount';
import { feature as saferGamblingModals } from '@myaccount/safer-gambling-modals';
import { feature as obSessionService } from '@central-products/obsession-service';
import { feature as promotionsFlow } from '@central-products/promotions-flow';
import { feature as hiddenMarketsWidgetFlow } from '@central-products/hidden-markets-widget-flow';
import { feature as smartBannersFlow } from '@central-products/smart-banners-flow';
import { isDeviceNative } from './utils/deviceDetection';

const availableBootstrapFeatures = {
  accountActions,
  accountActionsHandler,
  accountFlags,
  accountFlagsFlow,
  accountInfo,
  accountPreferences,
  casSessionManager,
  oauthSessionManager,
  graphqlClient,
  loginFlow,
  myaccountService,
  obSessionService,
  recaptchaService,
  registrationFlow,
  sessionService,
  promotionsFlow,
  saferGamblingModals,
  hiddenMarketsWidgetFlow,
  smartBannersFlow,
};

const getBootstrapFeatures = (requiredFeatures, deviceType) => {
  const isNative = isDeviceNative();
  return Object.keys(requiredFeatures)
    .filter((feature) => {
      const isEnabled = requiredFeatures[feature];
      if (typeof isEnabled === 'object') {
        return !!isEnabled[isNative ? `${deviceType}Native` : deviceType];
      }
      return !!isEnabled;
    })
    .map((feature) => availableBootstrapFeatures[feature])
    .filter((x) => x);
};

export default getBootstrapFeatures;
